
const countValueLinkedKPIs = (initiative) => {
    if (!initiative || !initiative.KPI || !Array.isArray(initiative.KPI)) {
      return 0;
    }
  
    let valueLinkedCount = 0;
    initiative.KPI.forEach((kpi) => {
      if (kpi && kpi.TypeOfKPI === 'Value linked') {
        valueLinkedCount++;
      }
    });
  
    return valueLinkedCount;
  };
  
  export default countValueLinkedKPIs;